import loadable from '@loadable/component';
import './ModalButton.css';

export default loadable(() => {
  return import('./ModalButton.jsx');
});
